import React from 'react';

export default function Terms() {
  return (
    <div className="pt-32 pb-24 bg-light min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-gray-100">
        <h1 className="text-3xl md:text-4xl font-bold text-navy mb-6">Syarat dan Ketentuan</h1>
        <div className="w-20 h-1.5 bg-orange mb-8 rounded-full"></div>

        <div className="space-y-6 text-gray-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-navy mb-3">1. Pendahuluan</h2>
            <p>Selamat datang di Garuda Ekspress Logistik. Syarat dan ketentuan ini mengatur penggunaan layanan pengiriman, logistik, dan website kami. Dengan menggunakan layanan maupun mengakses website kami, Anda menyetujui seluruh syarat dan ketentuan yang berlaku.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-navy mb-3">2. Layanan Pengiriman</h2>
            <p>Garuda Ekspress Logistik berhak menolak pengiriman barang yang melanggar hukum, barang berbahaya, barang mudah terbakar, atau barang-barang terlarang lainnya sesuai dengan peraturan perundang-undangan yang berlaku di Negara Kesatuan Republik Indonesia.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-navy mb-3">3. Tanggung Jawab dan Asuransi</h2>
            <p>Kami bertanggung jawab atas keamanan barang selama dalam pengawasan kami. Namun, untuk pengiriman barang bernilai tinggi sangat disarankan untuk menggunakan fitur asuransi tambahan. Penggantian atas kehilangan barang tanpa asuransi akan disesuaikan dengan standar regulasi kargo yang berlaku.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-navy mb-3">4. Klaim dan Pengaduan</h2>
            <p>Klaim atas kerusakan atau kehilangan barang harus diajukan kepada layanan pelanggan kami maksimal 3x24 jam setelah status barang dinyatakan diterima. Klaim yang melewati batas waktu tersebut tidak akan diproses oleh tim kami.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-navy mb-3">5. Perubahan Syarat dan Ketentuan</h2>
            <p>Kami dapat merevisi atau memperbarui syarat dan ketentuan ini sewaktu-waktu tanpa pemberitahuan sebelumnya. Perubahan akan berlaku secara efektif segera setelah dipublikasikan di halaman ini.</p>
          </section>
        </div>
      </div>
    </div>
  );
}